module.exports = __webpack_public_path__ + "d1dcf95138a763685b37b905c7a57b67.MP3";